import { FirestoreService } from "../../../api/firebase/firestoreService";

export async function saveAnswers(
  orderId: string,
  answers: Record<string, any>,
): Promise<void> {
  try {
    const path = `/medical_pa_orders/${orderId}/medical_necessity_review`;
    const documentId = "user_answers";

    await FirestoreService.updateDocument(path, documentId, {
      answers,
      saved_at: new Date(),
      updated_at: new Date(),
    });
  } catch (error) {
    console.error("Error saving medical necessity answers:", error);
    throw error;
  }
}
